import gsap from 'gsap';

const magazineCategorySelect = () => {
    const button = document.querySelector('.jsMagazineCategorySelectButton');
    const content = document.querySelector('.jsMagazineCategorySelectContent');

    if(!(button && content)) return;

    const icon = button.querySelector('svg');
    const timeLine = gsap.timeline({reversed: true});

    // 各要素の初期状態を設定
    gsap.set(icon, {
        rotation: '0deg'
    });
    gsap.set(content, {
        height: 0
    });

    timeLine
        .to(icon, {
            rotation: '-180deg',
            ease: 'none',
            duration: 0.25
        }, 'contentOpen') // 同じラベルを同時起動させる
        .to(content, {
            height: 'auto',
            ease: 'none',
            duration: 0.25
        }, 'contentOpen')

    button.addEventListener('click', () => {
        if (timeLine.reversed()) {
            timeLine.play();
        } else {
            timeLine.reverse();
        }
    });
}

export { magazineCategorySelect };